var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import axios from "axios";
const api = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});
const request = (method, url, params, data, authToken, noData, timeout) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        noData = noData || false;
        const config = {
            url,
            method,
            params,
            data,
            timeout,
        };
        if (authToken)
            config.headers = {
                Authorization: `Bearer ${authToken}`,
            };
        const { err, res: response } = yield to(api.request(config));
        // console.log("response", response, "err", err);
        if (noData)
            return response;
        if (err || !(response === null || response === void 0 ? void 0 : response.data))
            throw (err === null || err === void 0 ? void 0 : err.response.data) || err;
        const result = response.data;
        if (!result.success || result.error || !result.data)
            throw result.error;
        return result.data;
    }
    catch (error) {
        //console.log(url, method, data, error);
        console.error("API error", error);
        return null;
    }
});
export const post = (url, data, authToken, timeout) => __awaiter(void 0, void 0, void 0, function* () {
    return request("POST", url, undefined, data, authToken, false, timeout);
});
export const postNoData = (url, data, authToken) => __awaiter(void 0, void 0, void 0, function* () {
    return request("POST", url, undefined, data, authToken, true);
});
export const get = (url, params, authToken, noData) => __awaiter(void 0, void 0, void 0, function* () {
    return request("GET", url, params, undefined, authToken, noData);
});
export const put = (url, data, authToken) => __awaiter(void 0, void 0, void 0, function* () {
    return request("PUT", url, undefined, data, authToken);
});
export const del = (url, authToken) => __awaiter(void 0, void 0, void 0, function* () {
    return request("DELETE", url, undefined, undefined, authToken);
});
